import IOrder from "../../../models/IOrder";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./DailyRouteStatusWarningModal.scss";

type Props = {
    ordersNeedingStatusChange: IOrder[];
    proceedFn: () => void;
    cancelFn: () => void;
};

export const DailyRouteStatusWarningModal = (props: Props) => {
    return (
        <div className="DailyRouteStatusWarningModal p-4">
            <OwTitle title="order_status_warning" leftIconName="fad fa-exclamation-triangle" tag="h4" />

            <div className="mt-3">
                <OwLabel title="orders_will_be_moved_to_ready_status" className="text-warning" />
            </div>

            <div className="order-list mt-3 mb-3">
                {props.ordersNeedingStatusChange.map((order) => (
                    <div key={order.guid} className="order-item">
                        <span className="order-name">{order.name}</span>
                        <span className="order-status text-muted ms-2">({order.Order_State?.name || "unknown"})</span>
                    </div>
                ))}
            </div>

            <div className="warning-notes mt-3">
                <div className="note">
                    <i className="fas fa-info-circle text-warning me-2" />
                    <OwLabel title="intermediate_workflow_steps_will_be_skipped" />
                </div>
                <div className="note mt-2">
                    <i className="fas fa-info-circle text-warning me-2" />
                    <OwLabel title="workflow_actions_will_execute" />
                </div>
            </div>

            <div className="mt-4 text-center">
                <OwButton title="proceed" fn={props.proceedFn} />
                <OwButton title="cancel" className="ms-2 text-danger" fn={props.cancelFn} />
            </div>
        </div>
    );
};
